import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { PasswordResetRequestComponent } from './password-reset-request/password-reset-request.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { SharedModule } from '../shared/shared.module';
import { SalonMonsterLoadMaskModule } from '../shared/components/sm-load-mask/sm-load-mask.module';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    PasswordResetRequestComponent,
    PasswordResetComponent
  ],
  imports: [
    BrowserModule,
    // MaterialModule,
    // MdCardModule,
    // matInputModule,
    MatCardModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    SalonMonsterLoadMaskModule,
    TranslateModule,
  ],
  exports: [
  ],
  providers: [

  ],
  bootstrap: []
})
export class PasswordResetModule { }
